import api from "./api";

export const bankService = {
  // Get user's bank accounts
  getUserBanks: async () => {
    const response = await api.get("/bank");
    return response.data;
  },

  // Add bank account
  addBankAccount: async (bankData) => {
    const response = await api.post("/bank", bankData);
    return response.data;
  },

  // Delete bank account
  deleteBankAccount: async (bankId) => {
    const response = await api.delete(`/bank/${bankId}`);
    return response.data;
  },

  // Update bank account
  updateBankAccount: async (bankId, bankData) => {
    const response = await api.put(`/banks/${bankId}`, bankData);
    return response.data;
  },

  // Set selected payment bank (for agents)
  setSelectedPaymentBank: async (bankId) => {
    const response = await api.post("/bank/select-payment", { bankId });
    return response.data;
  },

  // Get selected payment bank (for agents)
  getSelectedPaymentBank: async () => {
    const response = await api.get("/bank/selected-payment");
    return response.data;
  },

  // Get bank by ID (for admin)
  getBankById: async (bankId) => {
    const response = await api.get(`/bank/${bankId}`);
    return response.data;
  },

  listPaystackBanks: async () => {
    const response = await api.get("/bank/paystack");
    return response.data?.data?.banks || [];
  },

  resolveAccount: async ({ accountNumber, bankCode }) => {
    const response = await api.get("/bank/resolve", { params: { accountNumber, bankCode } });
    return response.data?.data?.account;
  },
};
